import { ReactNode } from "react";
import { SettingsTab } from "@/access/userTypes";
import { TAB_META_BY_KEY } from "./settingsTabs";

/** The vertical tab list + content area, in the same design as the Agents Settings page. */
export function SettingsFrame({
  tabs,
  active,
  onSelect,
  children,
}: {
  tabs: SettingsTab[];
  active: SettingsTab;
  onSelect: (t: SettingsTab) => void;
  children: ReactNode;
}) {
  return (
    <div className="flex h-full" data-testid="settings-frame">
      <div className="w-52 shrink-0 border-r border-black/[0.06] bg-gray-50/50 p-3">
        <nav className="space-y-0.5">
          {tabs.map((k) => {
            const t = TAB_META_BY_KEY[k];
            return (
              <button
                key={k}
                data-testid={`settings-tab-${k}`}
                onClick={() => onSelect(k)}
                className={`flex w-full items-center gap-2.5 rounded-lg px-3 py-2 text-[13px] font-medium transition-all duration-150 ${
                  active === k ? "bg-gray-900 text-white shadow-sm" : "text-gray-500 hover:bg-gray-100 hover:text-gray-700"
                }`}
              >
                <span className={active === k ? "text-white" : "text-gray-400"}>{t.icon}</span>
                {t.label}
              </button>
            );
          })}
        </nav>
      </div>
      <div className="flex-1 overflow-y-auto">
        <div className="mx-auto max-w-3xl px-8 py-8 pb-24">{children}</div>
      </div>
    </div>
  );
}
